// extracted by mini-css-extract-plugin
module.exports = {"container":"NewGradingInfoBox_container__VRQN_"};